export default __webpack_public_path__ + "c77c4c871e5c9fd2075dc2e4d1facf5f.png";